/**
 * Mã màn hình
 */
export default {
    Login: 'Đăng nhập', // Đăng nhập
    Transaction: 'Transaction', // Hành động 
    Periodic: 'Định kỳ', // Định kỳ 
    LoginAndTransaction: 'Đăng nhập & Transaction', // Đăng nhập và hành động
  };
  